var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9253 42H10.9284C9.85973 42 9 41.1403 9 40.0716v-1.9283c0-1.0686.85973-1.9284 1.9284-1.9284h26.9969c1.0687 0 1.9284.8598 1.9284 1.9284v1.9283c0 1.0687-.8597 1.9284-1.9284 1.9284zM16.2635 18.7352l5.2708 5.2708V7.92835C21.5343 6.85972 22.394 6 23.4627 6h1.9283c1.0687 0 1.9284.85972 1.9284 1.92835V24.006l5.2708-5.2708c.7553-.7553 1.9766-.7553 2.7238 0l1.3659 1.3659c.7553.7553.7553 1.9766 0 2.7238L25.7928 33.7201c-.7553.7553-1.9766.7553-2.7238 0L12.1738 22.8329c-.7553-.7552-.7553-1.9765 0-2.7238l1.3659-1.3659c.7552-.7553 1.9765-.7553 2.7238-.008z",
    fill: "#858199"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceive);
export default __webpack_public_path__ + "static/media/iconReceive.a6428068.svg";
export { ForwardRef as ReactComponent };